import { render, staticRenderFns } from "./InscripcionCursadosAlum.vue?vue&type=template&id=332aa83c&scoped=true&"
import script from "./InscripcionCursadosAlum.vue?vue&type=script&lang=js&"
export * from "./InscripcionCursadosAlum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332aa83c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
